import slick from '../modules/slick';

export default () => {
    slick($('.gallery__slider').not('.slick-initialized'),
        {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        fade: false,
        responsive: [
            {
                breakpoint: 1439,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1
                }
            }
        ],
        prevArrow: '.gallery__slider-prev',
        nextArrow: '.gallery__slider-next'
    });
};


// WEBPACK FOOTER //
// ./templates/bazis/assets/js/jQueryApplication/components/gallery.js